interface UserStorageContext {
  id?: number | null
}

export const LEGACY_LAST_SELECTED_STORAGE_KEY = 'setSiteStudySelectedId'
const SCOPED_LAST_SELECTED_STORAGE_PREFIX = `${LEGACY_LAST_SELECTED_STORAGE_KEY}:`

const getScopedStorageKey = (user?: UserStorageContext | null): string | null => {
  const userId = user?.id
  if (!Number.isFinite(userId) || Number(userId) <= 0) {
    return null
  }

  return `${SCOPED_LAST_SELECTED_STORAGE_PREFIX}${userId}`
}

export const readLastSelectedFolderId = (user?: UserStorageContext | null): number | null => {
  const scopedKey = getScopedStorageKey(user)
  const candidateKeys = scopedKey ? [scopedKey, LEGACY_LAST_SELECTED_STORAGE_KEY] : [LEGACY_LAST_SELECTED_STORAGE_KEY]

  for (const key of candidateKeys) {
    const value = localStorage.getItem(key)
    const numericId = value ? Number(value) : NaN
    if (Number.isFinite(numericId) && numericId > 0) {
      return numericId
    }
  }

  return null
}

export const writeLastSelectedFolderId = (user: UserStorageContext | null | undefined, folderId: number): void => {
  if (!Number.isFinite(folderId) || folderId <= 0) {
    return
  }

  const scopedKey = getScopedStorageKey(user)
  if (scopedKey) {
    localStorage.setItem(scopedKey, String(folderId))
    return
  }

  localStorage.setItem(LEGACY_LAST_SELECTED_STORAGE_KEY, String(folderId))
}

export const clearLastSelectedFolderId = (user?: UserStorageContext | null): void => {
  const scopedKey = getScopedStorageKey(user)
  if (scopedKey) {
    localStorage.removeItem(scopedKey)
  }
  localStorage.removeItem(LEGACY_LAST_SELECTED_STORAGE_KEY)
}

export const clearAllLastSelectedFolderIds = (): void => {
  localStorage.removeItem(LEGACY_LAST_SELECTED_STORAGE_KEY)

  const keysToDelete: string[] = []
  for (let index = 0; index < localStorage.length; index++) {
    const key = localStorage.key(index)
    if (key?.startsWith(SCOPED_LAST_SELECTED_STORAGE_PREFIX)) {
      keysToDelete.push(key)
    }
  }

  keysToDelete.forEach((key) => {
    localStorage.removeItem(key)
  })
}
